export default __webpack_public_path__ + "static/media/epostal.1ee8b576.jpg";